import React, { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

function Principal() {
    const API_URL = "https://webapi.entab.info";
    const principalMessageUrl = `${API_URL}/api/PrincipalMessage/MMJSVN`;
    const fallbackImageUrl = `${API_URL}/api/image/MMJSVN/public/images/principal-25.jpg`;
    const [principalData, setPrincipalData] = useState({
        message: "",
        name: "Principal",
        imageUrl: fallbackImageUrl,
        loading: true,
        error: null,
    });
    useEffect(() => {
        const fetchPrincipalMessage = async () => {
            try {
                const response = await fetch(principalMessageUrl);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                const data = await response.json();

                const principalMessages = data.filter(
                    (item) => item.category.toLowerCase() === "principal"
                );

                if (principalMessages.length > 0) {
                    const messageData = principalMessages[0];
                    const imageUrl =
                        messageData.attachments && messageData.attachments.length > 0
                            ? `${API_URL}/api/image/${messageData.attachments[0]}`
                            : fallbackImageUrl;

                    setPrincipalData({
                        message: messageData.message || "No message available.",
                        name: messageData.name || "Principal",
                        imageUrl,
                        loading: false,
                        error: null,
                    });
                } else {
                    setPrincipalData((prev) => ({
                        ...prev,
                        message: "No message found for Principal.",
                        loading: false,
                    }));
                }
            } catch (error) {
                setPrincipalData({
                    message: "",
                    name: "Principal",
                    imageUrl: fallbackImageUrl,
                    loading: false,
                    error: "Failed to load principal message.",
                });
                console.error("Error fetching principal message:", error);
            }
        };

        fetchPrincipalMessage();
    }, []);

    const { message, name, imageUrl, loading, error } = principalData;

    return (
        <>
            <Header />
            <Breadcrumb
                title="Principal’s Message"
                midBreadcrumb="Message"
                mainBreadcrumb="Principal’s Message"
            />
            <div className="inner-page">
                <div className="container message">
                    <div className="row">
                        <div className="col-12">
                            <div className="clearfix">
                                <h2 className="mainhead">Principal’s Message</h2>
                                <img
                                    src={imageUrl}
                                    className="col-md-5 float-md-end rit-img  mx-auto d-block"
                                    alt="Mata Mariam Jan Seva Vidyalay"
                                />
                                {/* <div id="principal-message">
                                    {loading && <p>Loading principal's message...</p>}
                                    {error && <p className="error">{error}</p>}
                                    {!loading && !error && (
                                        <div dangerouslySetInnerHTML={{ __html: message }} />
                                    )}
                                </div> */}
                                <p>
                                    Warm greetings to all students, parents, teachers, and well-wishers of our school community.<br />
                                    It gives me immense joy to welcome you to our school website a window into the life, values, and aspirations of our institution. At the heart of our educational journey lies our <b>Motto: Solidarity of All Religions.</b> We firmly believe that true education nurtures respect, harmony, and unity among all people. By fostering an environment where every faith and culture is respected, we strive to build a campus enriched with peace, understanding, and mutual acceptance.<br />
                                    Guided by our <b>Vision-Service to God and Service to Nation-</b>we are committed to shaping individuals who recognize their responsibilities both to the Divine and to society. We encourage our students to uphold integrity, compassion, and selfless service, ensuring that they grow not only in knowledge but also in values that strengthen our nation.<br />
                                    Our <b>Mission</b> inspires us to form morally upright, spiritually conscious, intellectually smart, and socially responsible citizens. Every activity, lesson, and experience in our school is designed to help students develop strong character, deep spiritual awareness, critical thinking skills, and a genuine concern for the welfare of others. We aspire to produce young men and women who will contribute positively to society and lead with empathy and purpose.<br />
                                    As we continue to move forward, I invite all members of our school community to join hands in creating an atmosphere of learning, love, and service. Together, let us strive toward excellence while staying rooted in the timeless values that define our institution.</p>
                                <p>With Prayerful Regards</p>
                                <p>
                                    <strong>
                                        {name} <br />
                                        (Principal)
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Principal;
